import {
  Badge,
  Box,
  Flex,
  Heading,
  Image,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";

export const AboutSection: React.FC = () => {
  const bg = useColorModeValue("white", "gray.900");
  const textColor = useColorModeValue("gray.600", "gray.300");
  const headingColor = useColorModeValue("black", "white");

  return (
    <Box py={20} bg={bg}>
      <Flex
        maxW="container.xl"
        mx="auto"
        direction={{ base: "column", md: "row" }}
        align="center"
        px={6}
      >
        {/* Visual / Image Side */}
        <Box flex="1" mb={{ base: 10, md: 0 }} mr={{ md: 10 }}>
          <Image
            src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&q=80&w=800"
            alt="Cloud Infrastructure and Managed IT Network Visualization"
            borderRadius="lg"
            boxShadow="2xl"
            fallbackSrc="/img/logo-no-background.webp"
            objectFit="cover"
            maxH="500px"
            w="full"
          />
        </Box>

        {/* Content Side */}
        <Box flex="1">
          <Badge colorScheme="blue" mb={2}>
            Trusted Advisors
          </Badge>
          <Heading as="h2" size="xl" mb={4} fontWeight="bold" color={headingColor}>
            Architects of Strategy, <br />
            Not Just Resellers.
          </Heading>

          <Stack spacing={4} fontSize="lg" color={textColor}>
            <Text>
              TenK Solutions brings a unique perspective to top-tier IT consultancy.
              With <strong>15+ years of engineering experience</strong> spanning multiple industries, including deep roots in the <strong>AEC (Architecture, Engineering, Construction)</strong> sector, we approach technology infrastructure with the same rigor used in physical construction.
            </Text>
            <Text>
              We believe in "Hands-on Account Management." We don't just hand
              you a quote and disappear. By partnering with over 200 global technology suppliers, we sit on your side of the table to ensure the implementation matches the blueprint, without vendor bias.
            </Text>
            <Text
              fontStyle="italic"
              borderLeft="4px solid"
              borderColor="blue.500"
              pl={4}
            >
              "Our goal isn't to sell you a product. It's to empower your
              achievement through smart, safe, and efficient technical
              decisions."
            </Text>
          </Stack>
        </Box>
      </Flex>
    </Box>
  );
};
